import React, { useState, useEffect } from 'react';
import NumberRange from './NumberRange';

const SearchDOBRange = ({
    initData = {},
    onChange
}) => {
    // Generate options for dropdown lists
    const dayOptions = Array.from({ length: 31 }, (_, i) => (i + 1).toString());
    const monthOptions = Array.from({ length: 12 }, (_, i) => (i + 1).toString());
    
    // Initialize state with default empty values
    const [dobData, setDobData] = useState({
        // DOB giấy tờ (Documented DOB)
        paper_day_from: '',
        paper_day_to: '',
        paper_month_from: '',
        paper_month_to: '',
        paper_year_from: '',
        paper_year_to: '',
        paper_age_from: '',
        paper_age_to: '',
        // DOB thực tế (Actual DOB)
        actual_day_from: '',
        actual_day_to: '',
        actual_month_from: '',
        actual_month_to: '',
        actual_year_from: '',
        actual_year_to: '',
        actual_age_from: '',
        actual_age_to: ''
    });

    // Update state when initData changes
    useEffect(() => {
        if (initData && Object.keys(initData).length > 0) {
            setDobData(prevData => ({ ...prevData, ...initData }));
        }
    }, [initData]);

    // Handle change for a specific field
    const handleFieldChange = (field, value) => {
        const updatedData = { ...dobData, [field]: value };
        setDobData(updatedData);
        if (onChange) {
            onChange(updatedData);
        }
    };

    return (
        <div className='card card-default'>
            <div className='card-header'>
                <h3 className='card-title text-bold'>DOB</h3>
            </div>
            <div className='card card-body mt-0'>
                {/* DOB giấy tờ (Documented DOB) */}
                <NumberRange
                    title="DOB Giấy tờ"
                    labelStart="Ngày bắt đầu"
                    labelEnd="Ngày kết thúc"
                    startValue={dobData.paper_day_from ?? ''}
                    endValue={dobData.paper_day_to ?? ''}
                    onChangeStart={(e) => handleFieldChange('paper_day_from', e.target.value)}
                    onChangeEnd={(e) => handleFieldChange('paper_day_to', e.target.value)}
                    min="1"
                    max="31"
                    options={dayOptions}
                />
                
                <NumberRange
                    title=""
                    labelStart="Tháng bắt đầu"
                    labelEnd="Tháng kết thúc"
                    startValue={dobData.paper_month_from ?? ''}
                    endValue={dobData.paper_month_to ?? ''}
                    onChangeStart={(e) => handleFieldChange('paper_month_from', e.target.value)}
                    onChangeEnd={(e) => handleFieldChange('paper_month_to', e.target.value)}
                    containerClassName=""
                    min="1"
                    max="12"
                    options={monthOptions}
                />
                
                <NumberRange
                    title=""
                    labelStart="Năm bắt đầu"
                    labelEnd="Năm kết thúc"
                    startValue={dobData.paper_year_from ?? ''}
                    endValue={dobData.paper_year_to ?? ''}
                    onChangeStart={(e) => handleFieldChange('paper_year_from', e.target.value)}
                    onChangeEnd={(e) => handleFieldChange('paper_year_to', e.target.value)}
                    containerClassName=""
                    maxLength="4"
                />
                
                <NumberRange
                    title=""
                    labelStart="Tuổi bắt đầu"
                    labelEnd="Tuổi kết thúc"
                    startValue={dobData.paper_age_from ?? ''}
                    endValue={dobData.paper_age_to ?? ''}
                    onChangeStart={(e) => handleFieldChange('paper_age_from', e.target.value)}
                    onChangeEnd={(e) => handleFieldChange('paper_age_to', e.target.value)}
                    containerClassName=""
                    min="0"
                />

                {/* DOB thực tế (Actual DOB) */}
                <NumberRange
                    title="DOB thực tế"
                    labelStart="Ngày bắt đầu"
                    labelEnd="Ngày kết thúc"
                    startValue={dobData.actual_day_from ?? ''}
                    endValue={dobData.actual_day_to ?? ''}
                    onChangeStart={(e) => handleFieldChange('actual_day_from', e.target.value)}
                    onChangeEnd={(e) => handleFieldChange('actual_day_to', e.target.value)}
                    min="1"
                    max="31"
                />
                
                <NumberRange
                    title=""
                    labelStart="Tháng bắt đầu"
                    labelEnd="Tháng kết thúc"
                    startValue={dobData.actual_month_from ?? ''}
                    endValue={dobData.actual_month_to ?? ''}
                    onChangeStart={(e) => handleFieldChange('actual_month_from', e.target.value)}
                    onChangeEnd={(e) => handleFieldChange('actual_month_to', e.target.value)}
                    containerClassName=""
                    min="1"
                    max="12"
                />
                
                <NumberRange
                    title=""
                    labelStart="Năm bắt đầu"
                    labelEnd="Năm kết thúc"
                    startValue={dobData.actual_year_from ?? ''}
                    endValue={dobData.actual_year_to ?? ''}
                    onChangeStart={(e) => handleFieldChange('actual_year_from', e.target.value)}
                    onChangeEnd={(e) => handleFieldChange('actual_year_to', e.target.value)}
                    containerClassName=""
                    maxLength="4"
                />
                
                <NumberRange
                    title=""
                    labelStart="Tuổi bắt đầu"
                    labelEnd="Tuổi kết thúc"
                    startValue={dobData.actual_age_from ?? ''}
                    endValue={dobData.actual_age_to ?? ''}
                    onChangeStart={(e) => handleFieldChange('actual_age_from', e.target.value)}
                    onChangeEnd={(e) => handleFieldChange('actual_age_to', e.target.value)}
                    containerClassName=""
                    min="0"
                />
            </div>
        </div>
    );
};

export default SearchDOBRange;
